import { T } from "@supersig/validate";
import { z } from "zod";
export const Vec2dModelSchema = z.object({
    x: z.number(),
    y: z.number(),
    z: z.number().optional()
});
export const Box2dModelSchema = z.object({
    x: z.number(),
    y: z.number(),
    w: z.number(),
    h: z.number()
});
/** @public */ export const vec2dModelValidator = T.object({
    x: T.number,
    y: T.number,
    z: T.number.optional()
});
/** @public */ export const box2dModelValidator = T.object({
    x: T.number,
    y: T.number,
    w: T.number,
    h: T.number
});
